/**
 * Wraps a sync so at most one runs at a time. A call made while one is running
 * shares a single follow-up run that starts after it, so a waiter always sees a
 * sync that began after its request and slow syncs never build a backlog.
 */
export function serialSync(run: () => Promise<void>): () => Promise<void> {
  let running: Promise<void> | null = null;
  let queued: Promise<void> | null = null;

  const start = (): Promise<void> => {
    const p = run().finally(() => {
      if (running === p) running = null;
    });
    running = p;
    return p;
  };

  return () => {
    if (!running) return start();
    queued ??= running
      .catch(() => undefined)
      .then(() => {
        queued = null;
        return start();
      });
    return queued;
  };
}
